// FNP-1016: writes for the ApplicationInfrastructure inventory.
//
// ⚠️ THESE MUTATIONS RECORD REALITY. They create no AWS resources. The
// orchestrator calls `createApplicationInfrastructure` before it builds each
// resource; an admin calls the same mutation to register infrastructure that
// already exists and that this platform never provisioned.

import {APPLICATION_INFRASTRUCTURE_FIELDS} from './infrastructure-queries';

export const createApplicationInfrastructure = `
    mutation createApplicationInfrastructure($input: CreateApplicationInfrastructureInput!) {
        createApplicationInfrastructure(input: $input) {
            ${APPLICATION_INFRASTRUCTURE_FIELDS}
        }
    }
`;

// ⚠️ `stages` REPLACES the array wholesale when supplied — there is no
// per-stage merge. Callers read, amend and write the WHOLE array.
export const updateApplicationInfrastructure = `
    mutation updateApplicationInfrastructure($input: UpdateApplicationInfrastructureInput!) {
        updateApplicationInfrastructure(input: $input) {
            ${APPLICATION_INFRASTRUCTURE_FIELDS}
        }
    }
`;
